export { default } from './components/Tooltip';
export { TooltipPrimitive } from './styled';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/tooltip/dist/esm/index.js
// module id = 5975
// module chunks = 0